import {shallowRef} from 'vue';
import themeTitles from '@/core/constants/themes';
import {useStore} from '@/core/plugins/store';

export const useChartTheme = () => {
    const currentTheme = shallowRef(null);
    const selectedThemeTitle = shallowRef(null);
    const {store} = useStore();

    async function changeTheme(theme, callback) {
        if (!themeTitles.includes(theme)) {
            throw new Error('Theme not found!');
        }

        if (selectedThemeTitle.value === theme) {
            return;
        }

        const themeData = store.value.loadedThemes[theme];

        currentTheme.value = {...themeData};
        selectedThemeTitle.value = theme;
        typeof callback === 'function' && callback();
    }

    return {
        themeTitles,
        currentTheme,
        selectedThemeTitle,
        changeTheme,
    };
};
